export default __webpack_public_path__ + "e6f2e9aa80340250ed7feced401c1f87.png";